import styled from 'styled-components';

export const InputContain = styled.section`
  position: relative;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  margin: 0 20px;

  p {
    margin: 0 0 0.7rem;
    color: var(--texto-color);
    letter-spacing: 0.1rem;
  }
`;
